//const Backofficebff         : string = "/backofficebff/service/api/v1";
//const BackofficebffV2         : string = "/backofficebff/service/api/v2";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const ReportsQuery: any = {
    GetListOfReportsAuthorization: Backofficebff + '/v1/reportslist/listof-reports-list-authorization',
    GetListOfReportsListItem: Backofficebff + '/v1/reportslist/listof-reports-listitem',
    GetReportsListAuthorization: Backofficebff + '/v1/reportslist/get-reports-list-authorization',
    GetReportsListItem: Backofficebff + '/v1/reportslist/get-reports-listitem',
    GetListOfSelfReportsListItem: Backofficebff + '/v1/reportslist/listof-selfreports-listitem',
};
